var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ws-col",class:[`col-${_vm.cols}`,`sm-col-${_vm.smcols}`],style:({
    'justify-content': _vm.justifyContent,
  })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }